import commonSlice from '../common';
import { parityIllustrationSlice } from './parity-illustration';
import { postmenTitleSlice } from './postmen-title';
import { quotesSlice } from './quotes';
import { staffIllustrationSlice } from './staff-illustration';
import { textIllustrationsSlice } from './txt-n-illustrations';

const PRISMIC_TO_PARSER_SLICE = {
  ...commonSlice,
  postmenTitle: postmenTitleSlice,
  parityIllustration: parityIllustrationSlice,
  quotes: quotesSlice,
  staffIllustration: staffIllustrationSlice,
  txtIllustrations: textIllustrationsSlice,
};

export default PRISMIC_TO_PARSER_SLICE;
